import {Modal, SaveFooter, Text} from '@/components-v2'
import {useCallback, useState} from 'react'
import {BrandsSection} from './BrandSection/BrandSection'
import {CategoriesSection} from './CategorySection/CategoriesSection'
import {useProductCatalog} from '@/containers/Content/ProductCatalog/hooks/useProductCatalog'

export const ProductCatalog = () => {
  const catalog = useProductCatalog()
  const [isDiscardModalOpen, setDiscardModalOpen] = useState(false)
  const [isDragging, setDragging] = useState(false)
  const [busyBrands, setBusyBrands] = useState({})
  const isImageBusy = Object.values(busyBrands).some(Boolean)
  const isBusy = catalog.isPublishing || isImageBusy || isDragging

  const onBrandBusyChange = useCallback((id, busy) => {
    setBusyBrands(previous => {
      if (Boolean(previous[id]) === busy) return previous
      const next = {...previous}
      if (busy) next[id] = true
      else delete next[id]
      return next
    })
  }, [])

  const handleDiscard = () => {
    if (catalog.hasUnsavedChanges) setDiscardModalOpen(true)
    else catalog.discardChanges()
  }

  const keepEditing = () => {
    setDiscardModalOpen(false)
  }

  const confirmDiscard = () => {
    catalog.discardChanges()
    setDiscardModalOpen(false)
  }

  return (
    <div className="product-categories flex flex-col gap-6 pb-8">
      <Text headingLevel={3}>Product Categories</Text>
      {/* {catalog.isError && (
        <div className="flex items-center gap-4">
          <p>Unable to load the product catalog.</p>
        </div>
      )}
      {(!catalog.isError || catalog.brands.length > 0 || catalog.categories.length > 0) && ( */}
        <>
          <BrandsSection
            brands={catalog.brands}
            setBrands={catalog.setBrands}
            isLoading={catalog.isLoading}
            disabled={catalog.isPublishing}
            onDragEnd={catalog.handleBrandsReorder}
            onDraggingChange={setDragging}
            onBrandBusyChange={onBrandBusyChange}
          />
          <CategoriesSection
            categories={catalog.categories}
            isLoading={catalog.isLoading}
            isEditMode={catalog.isEditMode}
            disabled={catalog.isPublishing}
            onEnterEditMode={catalog.enterEditMode}
            moveItem={catalog.moveItem}
            getOriginalPosition={catalog.getOriginalPosition}
            directlyMoved={catalog.directlyMoved}
            onInputStateChange={catalog.onInputStateChange}
            onToggleSubcategoryVisibility={catalog.toggleSubcategoryVisibility}
            onDraggingChange={setDragging}
          />
        </>
      {/* )} */}
      <SaveFooter
        visible={catalog.isEditMode || catalog.hasUnsavedChanges || catalog.isPublishing}
        changedItemsCount={catalog.changedItemsCount}
        isSaving={catalog.isPublishing}
        saveDisabled={!catalog.hasUnsavedChanges || catalog.hasValidationErrors || isBusy}
        discardDisabled={isBusy}
        feedback={
          catalog.hasValidationErrors ? <span>Correct invalid order positions before saving.</span> : undefined
        }
        onSave={catalog.saveChanges}
        onDiscard={handleDiscard}
      />
      <Modal
        showModal={isDiscardModalOpen}
        onCloseModal={keepEditing}
        hideCloseButton
        type="S"
        title={'Discard changes'}
        text={'Your changes to the categories ordering, visibility and brands will not be saved.'}
        showPrimaryButton
        primaryButtonProps={{text: 'Keep editing', onClick: keepEditing}}
        showTertiaryButton
        tertiaryButtonProps={{text: 'Discard changes', onClick: confirmDiscard, disabled: isBusy}}
      />
    </div>
  )
}
